import { compareTDSDetails, viewTDSDetails, modifyTDSDetails } from 'api/home/myPay';
import { asyncThunkWrapper } from 'utils/AsyncThunkWrapper';

const fetchCompareTDS = asyncThunkWrapper('compareTDS/fetch', compareTDSDetails);
const fetchViewTDS = asyncThunkWrapper('viewTDS/fetch', viewTDSDetails);
const fetchModifyViewTDS = asyncThunkWrapper('modifyTDS/fetch', modifyTDSDetails);

export { fetchCompareTDS, fetchViewTDS, fetchModifyViewTDS };
